import "core-js/modules/es.array.reverse.js";
var _class, _GeoRssStratum, _class2, _GeoRssCatalogItem;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, runInAction, makeObservable } from "mobx";
import getFilenameFromUri from "terriajs-cesium/Source/Core/getFilenameFromUri";
import RuntimeError from "terriajs-cesium/Source/Core/RuntimeError";
import isDefined from "../../../Core/isDefined";
import loadXML from "../../../Core/loadXML";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import { networkRequestError } from "../../../Core/TerriaError";
import { geoRss2ToGeoJson, geoRssAtomToGeoJson } from "../../../Map/Vector/geoRssConvertor";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import GeoRssCatalogItemTraits from "../../../Traits/TraitsClasses/GeoRssCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import CommonStrata from "../../Definition/CommonStrata";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
var GeoRssFormat = /*#__PURE__*/function (GeoRssFormat) {
  GeoRssFormat["RSS"] = "rss";
  GeoRssFormat["ATOM"] = "feed";
  return GeoRssFormat;
}(GeoRssFormat || {});
let GeoRssStratum = (_class = (_GeoRssStratum = class GeoRssStratum extends LoadableStratum(GeoRssCatalogItemTraits) {
  constructor(_item, _feed) {
    super();
    this._item = _item;
    this._feed = _feed;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new GeoRssStratum(newModel, this._feed);
  }
  get name() {
    if (this._feed && this._feed.title && this._feed.title.length > 0) {
      return replaceUnderscores(this._feed.title);
    }
    return super.name;
  }
  get dataCustodian() {
    if (this._feed && this._feed.author && this._feed.author.name && this._feed.author.name.length > 0) {
      return this._feed.author.name;
    }
  }
  get info() {
    var _this$_feed$updated, _this$_feed$category, _this$_feed$author, _this$_feed$link;
    if (!this._feed) {
      return [];
    }
    return [createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.subtitle"),
      content: this._feed.subtitle
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.updated"),
      content: (_this$_feed$updated = this._feed.updated) === null || _this$_feed$updated === void 0 ? void 0 : _this$_feed$updated.toString()
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.category"),
      content: (_this$_feed$category = this._feed.category) === null || _this$_feed$category === void 0 ? void 0 : _this$_feed$category.join(", ")
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.description"),
      content: this._feed.description
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.copyrightText"),
      content: this._feed.copyright
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.author"),
      content: (_this$_feed$author = this._feed.author) === null || _this$_feed$author === void 0 ? void 0 : _this$_feed$author.name
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.georss.link"),
      content: typeof this._feed.link === "string" ? this._feed.link : (_this$_feed$link = this._feed.link) === null || _this$_feed$link === void 0 ? void 0 : _this$_feed$link.join(", ")
    })];
  }
}, _defineProperty(_GeoRssStratum, "stratumName", "georss"), _GeoRssStratum), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataCustodian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _class);
StratumOrder.addLoadStratum(GeoRssStratum.stratumName);
let GeoRssCatalogItem = (_class2 = (_GeoRssCatalogItem = class GeoRssCatalogItem extends GeoJsonMixin(CreateModel(GeoRssCatalogItemTraits)) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return GeoRssCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.georss.name");
  }
  setFileInput(file) {
    this.setTrait(CommonStrata.user, "url", URL.createObjectURL(file) + "#" + file.name);
  }
  get hasLocalData() {
    var _this$url$startsWith, _this$url;
    return (_this$url$startsWith = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.startsWith("blob:")) !== null && _this$url$startsWith !== void 0 ? _this$url$startsWith : false;
  }
  parseGeorss(xmlData) {
    const documentElement = xmlData.documentElement;
    let json;
    let metadata;
    if (documentElement.localName.includes(GeoRssFormat.ATOM)) {
      metadata = parseMetadata(documentElement.childNodes, this);
      json = geoRssAtomToGeoJson(xmlData);
    } else if (documentElement.localName === GeoRssFormat.RSS) {
      const element = documentElement.getElementsByTagName("channel")[0];
      metadata = parseMetadata(element.childNodes, this);
      json = geoRss2ToGeoJson(xmlData);
    } else {
      throw new RuntimeError("document is not valid");
    }
    runInAction(() => {
      this.strata.set(GeoRssStratum.stratumName, new GeoRssStratum(this, metadata));
    });
    return json;
  }
  async forceLoadGeojsonData() {
    let data;
    if (isDefined(this.geoRssString)) {
      const parser = new DOMParser();
      data = parser.parseFromString(this.geoRssString, "text/xml");
    } else if (isDefined(this.url)) {
      data = await loadXML(proxyCatalogItemUrl(this, this.url));
    }
    if (!data) {
      throw networkRequestError({
        sender: this,
        title: i18next.t("models.georss.errorLoadingTitle"),
        message: i18next.t("models.georss.errorLoadingMessage", {
          appName: this.terria.appName
        })
      });
    }
    return this.parseGeorss(data);
  }
  forceLoadMetadata() {
    return Promise.resolve();
  }
}, _defineProperty(_GeoRssCatalogItem, "type", "georss"), _GeoRssCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setFileInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasLocalData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasLocalData"), _class2.prototype), _class2);
export { GeoRssCatalogItem as default };
function parseMetadata(xmlElements, item) {
  const result = {};
  result.link = [];
  result.category = [];
  for (let i = 0; i < xmlElements.length; ++i) {
    const child = xmlElements[i];
    if (child.nodeType !== 1 || child.localName === "item" || child.localName === "entry") {
      continue;
    }
    if (child.localName === "id") {
      result.id = child.textContent || undefined;
    } else if (child.localName === "title") {
      result.title = child.textContent || undefined;
    } else if (child.localName === "subtitle") {
      result.subtitle = child.textContent || undefined;
    } else if (child.localName === "description") {
      result.description = child.textContent || undefined;
    } else if (child.localName === "category") {
      if (child.textContent) {
        result.category.push(child.textContent);
      }
    } else if (child.localName === "link") {
      if (child.textContent) {
        result.link.push(child.textContent);
      } else {
        const href = child.getAttribute("href");
        if (href) {
          result.link.push(href);
        }
      }
    } else if (child.localName === "updated") {
      result.updated = child.textContent || undefined;
    } else if (child.localName === "rights" || child.localName === "copyright") {
      result.copyright = child.textContent || undefined;
    } else if (child.localName === "author") {
      const authorNode = child.childNodes;
      if (authorNode.length === 0) {
        result.author = {
          name: child.textContent || undefined
        };
      } else {
        let name, email, link;
        for (let authorIndex = 0; authorIndex < authorNode.length; ++authorIndex) {
          const authorChild = authorNode[authorIndex];
          if (authorChild.nodeType === 1) {
            if (authorChild.localName === "name") {
              name = authorChild.textContent || undefined;
            } else if (authorChild.localName === "email") {
              email = authorChild.textContent || undefined;
            }
            if (authorChild.localName === "link") {
              link = authorChild.textContent || undefined;
            }
          }
        }
        result.author = {
          name: name,
          email: email,
          link: link
        };
      }
    }
  }
  if (item.url && (!isDefined(result.title) || result.title === item.url)) {
    result.title = getFilenameFromUri(item.url);
  }
  return result;
}